var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E7424C",
  fillRule: "evenodd",
  d: "M9 15.23A6.23 6.23 0 1 0 9 2.77a6.23 6.23 0 0 0 0 12.46M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18",
  clipRule: "evenodd"
})));
export default SvgIcPass;